// DebugIdBox.web.tsx

import React from "react"
import { View, TouchableOpacity } from "react-native"
import * as Clipboard from "expo-clipboard"
import { H5, Tiny } from "@/components/standard/BFText"
import { showActionToast, showErrorToast } from "@/components/toasts/AppToast"
import { useUser } from "@/queries/user"

const DebugIdBox = () => {
  const { data: userData } = useUser()
  const { id: userId } = userData?.me || {}

  const copyToClipboard = async () => {
    try {
      await Clipboard.setStringAsync(userId || "N/A")
      showActionToast({
        title: "Copied!",
        message: "User ID copied to clipboard.",
      })
    } catch (error) {
      showErrorToast({ message: "Failed to copy to clipboard." })
    }
  }

  return (
    <View className="flex flex-col w-full border rounded border-light-grey p-4 mb-2">
      <H5>User Information:</H5>
      {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
      <TouchableOpacity testID={"copy-to-clipboard"} onPress={copyToClipboard}>
        <Tiny className="text-blue-500 underline">{`User ID: ${userId}`}</Tiny>
      </TouchableOpacity>
    </View>
  )
}

export default DebugIdBox
